import ImageZoom from "@/components/imageZoom";
import { Button, TableBody, TableFooter } from "@mui/material";
import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import Table from "@mui/material/Table";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Typography from "@mui/material/Typography";

import _ from "lodash";
import moment from "moment";
import React from "react";

export default function GiveawayDetailDialog(props) {
  const { onCancel, open, data, handleCheckClick } = props;
  const groupByHiddenOffers = _.groupBy(
    data?.giveaway,
    (g) => g.hidden_offer_name ?? g.coupon_name,
  );

  const renderCard = (data) => {
    return (
      <React.Fragment>
        {data.reason_types_name === "PharmaGoods" ? (
          <Typography>
            {data.reason_types_name}（
            {data.reason_types_id === 11 ? "Hidden Offer" : "換取已預約贈品"}）
          </Typography>
        ) : (
          <Typography>{data.reason_types_name}</Typography>
        )}
        {data.fullname && (
          <Typography>
            <b>名稱：</b>
            {data.fullname}
          </Typography>
        )}
        <Typography>
          <b>電話：</b>
          {data.phone}
        </Typography>
        <Typography>
          <b>收據日期：</b>
          {data.receipt_invoice_date
            ? moment(data.receipt_invoice_date).format("YYYY-MM-DD")
            : "未能偵測"}
        </Typography>
        <Typography>
          <b>換領地點：</b>
          {data.work_name ?? data.base_work_name}
        </Typography>
        {data.subscription_method && (
          <Typography>
            <b>接收推廣優惠頻道：</b>
            {data.subscription_method.map((m) => m.toUpperCase()).join(",")}
          </Typography>
        )}
      </React.Fragment>
    );
  };
  return (
    <Dialog open={open} onClose={onCancel} fullWidth maxWidth={"lg"}>
      <DialogContent>
        <Box sx={{ display: "flex" }}>
          <Box sx={{ width: 300, margin: 1 }}>
            <Card
              variant="outlined"
              sx={{
                minHeight: 160,
                backgroundColor: "#0A9C75",
                borderRadius: 5,
              }}
            >
              <CardContent sx={{ color: "white" }}>
                <Typography sx={{ marginBottom: 1 }} variant="h6">
                  登記資料
                </Typography>
                {renderCard(data)}
              </CardContent>
            </Card>
          </Box>
          <Box sx={{ width: 300, margin: 1 }}>
            <Card
              variant="outlined"
              sx={{
                minHeight: 160,
                backgroundColor: "#0A9C75",
                borderRadius: 5,
              }}
            >
              <CardContent sx={{ color: "white" }}>
                <Typography sx={{ marginBottom: 1 }} variant="h6">
                  員工資料
                </Typography>
                <React.Fragment>
                  <Typography>
                    <b>編號：</b>
                    {data.staff_code}
                  </Typography>
                  <Typography>
                    <b>名稱：</b>
                    {data.alias}
                  </Typography>
                </React.Fragment>
              </CardContent>
            </Card>
          </Box>

          {!_.isEmpty(data.attachments) && (
            <Box sx={{ width: 500, marginLeft: 1 }}>
              <ImageZoom attachments={data.attachments}></ImageZoom>
            </Box>
          )}
        </Box>
        <Box
          sx={{ display: "flex", justifyContent: "space-between", margin: 1 }}
        >
          <div>
            {data.auto_check_reasons && data.is_auto_check_valid === false && (
              <Typography color="error">
                <b>系統自動檢查結果:</b>
                {data.auto_check_reasons.map((reason, index) => {
                  return (
                    <Typography variant="body2">
                      {index + 1}. {reason}
                    </Typography>
                  );
                })}
              </Typography>
            )}
          </div>
          <div>
            {data.is_checked ? (
              <Button color={"success"} variant="contained">
                已檢查
              </Button>
            ) : (
              <Button onClick={() => handleCheckClick(data)} variant="outlined">
                待檢查
              </Button>
            )}
          </div>
        </Box>
        <Box
          sx={{
            display: "flex",
            fontSize: "18px",
            textDecoration: "underline",
          }}
        >
          {data?.purchase?.length > 0 && (
            <Box
              sx={{
                flex: 0.6,
                display: "flex",
                justifyContent: "center",
              }}
            >
              購買紀錄
            </Box>
          )}
          <Box
            sx={{
              flex: data?.purchase?.length > 0 ? 0.4 : 1,
              display: "flex",
              justifyContent: "center",
            }}
          >
            換領紀錄
          </Box>
        </Box>

        <Box sx={{ display: "flex" }}>
          {data?.purchase?.length > 0 && (
            <TableContainer sx={{ height: 400, flex: 0.6 }}>
              <Table
                size="small"
                stickyHeader
                style={{ width: "100%", borderRight: "1px solid" }}
              >
                <TableHead>
                  <TableRow>
                    <TableCell>產品名稱</TableCell>
                    <TableCell>價錢</TableCell>
                    <TableCell align="right">購買數量</TableCell>
                    <TableCell align="right">小計</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {data?.purchase?.map((d) => {
                    const textDecorationLine = d.discount_name
                      ? "line-through"
                      : "none";
                    return (
                      <TableRow>
                        <TableCell>{d.name}</TableCell>
                        <TableCell>
                          <div style={{ display: "flex" }}>
                            <Typography
                              noWrap
                              component="p"
                              sx={{
                                textDecorationLine: textDecorationLine,
                              }}
                              variant={"body2"}
                            >
                              ${d.product_unit_price}
                            </Typography>
                            {d.discount_name && (
                              <Typography
                                noWrap
                                component="p"
                                sx={{
                                  color: "red",
                                  marginLeft: 1,
                                }}
                                variant={"body2"}
                              >
                                ${d.discount_price} ({d.discount_name})
                              </Typography>
                            )}
                          </div>
                        </TableCell>
                        <TableCell align="right">{d.qty}</TableCell>
                        <TableCell align="right">
                          {new Intl.NumberFormat("en-US", {
                            style: "currency",
                            currency: "HKD",
                          }).format(d.sub_total)}
                        </TableCell>
                      </TableRow>
                    );
                  })}
                </TableBody>
                <TableFooter
                  sx={{
                    position: "sticky",
                    insetBlockEnd: 0,
                    backgroundColor: "white",
                  }}
                >
                  <TableRow>
                    <TableCell></TableCell>
                    <TableCell align="right">總數：</TableCell>
                    <TableCell
                      sx={{
                        fontWeight: "bold",
                        textDecoration: "underline",
                      }}
                      align="right"
                    >
                      {_.sumBy(data?.purchase, "qty")}
                    </TableCell>
                    <TableCell
                      sx={{
                        fontWeight: "bold",
                        textDecoration: "underline",
                      }}
                      align="right"
                    >
                      {new Intl.NumberFormat("en-US", {
                        style: "currency",
                        currency: "HKD",
                      }).format(_.sumBy(data?.purchase, "sub_total"))}
                    </TableCell>
                  </TableRow>
                </TableFooter>
              </Table>
            </TableContainer>
          )}
          <TableContainer
            sx={{ height: 400, flex: data?.purchase?.length > 0 ? 0.4 : 1 }}
          >
            <Table size="small" stickyHeader style={{ width: "100%" }}>
              <TableHead>
                <TableRow>
                  <TableCell>贈品名稱</TableCell>
                  <TableCell align="right">換領數量</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {_.map(groupByHiddenOffers, (groupByHiddenOffer, name) => {
                  return (
                    <>
                      <TableRow>
                        <TableCell style={{ fontWeight: "bold" }}>
                          - {name}
                        </TableCell>
                      </TableRow>
                      {_.map(groupByHiddenOffer, (item) => {
                        return (
                          <TableRow>
                            <TableCell>{item.name}</TableCell>
                            <TableCell align="right">{item.qty}</TableCell>
                          </TableRow>
                        );
                      })}
                    </>
                  );
                })}
              </TableBody>
              <TableFooter
                sx={{
                  position: "sticky",
                  insetBlockEnd: 0,
                  backgroundColor: "white",
                }}
              >
                <TableRow>
                  <TableCell align="right">總數：</TableCell>
                  <TableCell
                    sx={{ fontWeight: "bold", textDecoration: "underline" }}
                    align="right"
                  >
                    {_.sumBy(data?.giveaway, (g) => parseInt(g.qty))}
                  </TableCell>
                </TableRow>
              </TableFooter>
            </Table>
          </TableContainer>
        </Box>
      </DialogContent>
    </Dialog>
  );
}
